import { render, staticRenderFns } from "./CaptchaSlider.vue?vue&type=template&id=047203ea&scoped=true"
import script from "./CaptchaSlider.vue?vue&type=script&lang=js"
export * from "./CaptchaSlider.vue?vue&type=script&lang=js"
import style0 from "./CaptchaSlider.vue?vue&type=style&index=0&id=047203ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047203ea",
  null
  
)

export default component.exports